import { Card, CircularProgress, Grid } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { TLSText } from "components/CustomComponents";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import PieChart from "examples/Charts/PieChart";
import DualAxisLineChart from "examples/Charts/LineCharts/DualAxisLineChart";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { roundToTwo } from "layouts/Helper/helper";
import { getSectorData } from "layouts/applications/data-tables/data/getData";
import { useEffect, useState } from "react";
import { StockInfoPopup } from "components/CustomPopups/StockPopups";
import { revenueData1 } from "layouts/pages/charts/data/pieChartData";
import { revenueData2 } from "layouts/pages/charts/data/barChartData";
import { getMarketCap } from "layouts/applications/data-tables/data/getData";
import SoftTypography from "components/SoftTypography";

export default () => {
  const [sector, setSector] = useState("XLB");
  const [loading, setLoading] = useState(false);
  const [sectorData, setSectorData] = useState(null);
  const [marketCap, setMarketCap] = useState(null);
  const [pieData, setPieData] = useState(null);

  const [popupAccessor, setPopupAccessor] = useState("");
  const [infoPopup, toggleInfoPopup] = useState(false);

  useEffect(() => {
    loadSectorData();
  }, [sector]);

  const loadSectorData = async () => {
    setLoading(true);
    setPieData(null);
    const sectorData = await getSectorData(sector);
    setSectorData(sectorData);

    revenueData1["labels"] = sectorData["Industry Allocation"]["Industries"];
    revenueData1["datasets"]["data"] = sectorData["Industry Allocation"]["Allocations"];

    setPieData(revenueData1);

    const marketCapData = await getMarketCap(sector);

    revenueData2["labels"] = marketCapData["Date"];
    revenueData2["datasets"][1]["data"] = marketCapData["SPY Market Cap"];
    revenueData2["datasets"][0]["data"] = marketCapData["Sector Market Cap"];
    revenueData2["datasets"][0]["label"] = sector;
    setMarketCap(revenueData2);

    setLoading(false);
  };

  const handleInfoPop = (popupAccessor) => {
    toggleInfoPopup(true);
    setPopupAccessor(popupAccessor);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={`Sectors :: ${sector}`} />
      <Grid container>
        <Grid className="dashboardsCardsFull" item>
          <div
            style={{
              marginTop: "18px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <h5 className="roboto" style={{ marginRight: "5px" }}>
              Sectors
            </h5>
          </div>

          <div
            className="stocksDescDiv bbvColourwhite "
            style={{
              display: "flex",
              justifyContent: "space-between",
              position: "sticky",
              top: 150,
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <SoftButton
              className={sector === "XLB" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLB");
              }}
            >
              Materials
              <br />
              (XLB)
            </SoftButton>

            <SoftButton
              className={sector === "XLE" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLE");
              }}
            >
              Energy
              <br />
              (XLE)
            </SoftButton>

            <SoftButton
              className={sector === "XLF" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLF");
              }}
            >
              Financial
              <br />
              (XLF)
            </SoftButton>

            <SoftButton
              className={sector === "XLI" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLI");
              }}
            >
              Industrial
              <br />
              (XLI)
            </SoftButton>
            <SoftButton
              className={sector === "XLK" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLK");
              }}
            >
              Technology
              <br />
              (XLK)
            </SoftButton>
            <SoftButton
              className={sector === "XLP" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLP");
              }}
            >
              Consumer
              <br />
              Staples
              <br />
              (XLP)
            </SoftButton>
            <SoftButton
              className={sector === "XLRE" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLRE");
              }}
            >
              Real
              <br />
              Estate
              <br />
              (XLRE)
            </SoftButton>
            <SoftButton
              className={sector === "XLU" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLU");
              }}
            >
              Utilities
              <br />
              (XLU)
            </SoftButton>
            <SoftButton
              className={sector === "XLV" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLV");
              }}
            >
              Healthcare
              <br />
              (XLV)
            </SoftButton>
            <SoftButton
              className={sector === "XLY" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLY");
              }}
            >
              Consumer
              <br />
              Discretion.
              <br />
              (XLY)
            </SoftButton>
            <SoftButton
              className={sector === "XLC" ? "bbvRed stockDescButtons" : "bbvGrey stockDescButtons"}
              onClick={() => {
                setSector("XLC");
              }}
            >
              Comm.
              <br />
              Services
              <br />
              (XLC)
            </SoftButton>
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid className="dashboardsCardsFull" item>
          <SoftBox mb={3}>
            <div style={{ backgroundColor: "white", borderRadius: "16px", marginTop: "20px", padding: "20px" }}>
              <p className="roboto" style={{ paddingBottom: "20px", fontSize: "18px" }}>
                Price Chart
              </p>
              <Card>
                <SoftBox p={2}>
                  <iframe
                    title="technical3"
                    src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview_fc027&symbol=${sector}&interval=D&saveimage=0&toolbarbg=f1f3f6&details=1&studies=RSI%40tv-basicstudies%1FCCI%40tv-basicstudies&theme=light&style=2&timezone=Etc%2FUTC&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%5D&locale=en&utm_source=&utm_medium=widget_new&utm_campaign=chart&utm_term=MSTR#%7B%22page-uri%22%3A%22__NHTTP__%22%7D`}
                    className="fullWidth"
                    style={{ height: "500px" }}
                  ></iframe>
                </SoftBox>
              </Card>
            </div>
          </SoftBox>
        </Grid>
      </Grid>
      <SoftBox mb={3}>
        <div style={{ backgroundColor: "white", borderRadius: "16px", marginTop: "20px", padding: "20px" }}>
          <div
            style={{
              marginBottom: "18px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
              Top Holdings
            </h3>
          </div>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingRight: "20px",
                paddingLeft: "20px",
                paddingBottom: "20px",
              }}
            >
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th
                      class=" bbvColour1"
                      style={{ color: "white", width: "70px", textAlign: "left", paddingLeft: "10px", height: "5px" }}
                    >
                      Rank
                    </th>
                    <th
                      class="bbvColour2"
                      style={{ color: "white", paddingLeft: "10px", textAlign: "left", height: "5px" }}
                    >
                      Company
                    </th>
                    <th
                      class="bbvColour1"
                      style={{ color: "white", paddingLeft: "10px", width: "200px", textAlign: "left", height: "5px" }}
                    >
                      Allocation
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sectorData && !loading ? (
                    <>
                      {sectorData["holdings"].map((row, index) => {
                        return (
                          <tr>
                            <td style={{ borderBottom: "1px solid #ddd", height: "40px", paddingTop: "10px" }}>
                              <div className="inline " style={{ paddingLeft: "5px", paddingRight: "18px" }}>
                                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                                  {row.Rank}
                                </p>
                              </div>
                            </td>
                            <td style={{ borderBottom: "1px solid #ddd" }}>
                              <div className="inline " style={{ paddingLeft: "5px", paddingRight: "18px" }}>
                                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                                  {row.Company}
                                </p>
                              </div>
                            </td>
                            <td style={{ borderBottom: "1px solid #ddd" }}>
                              <div className="inline " style={{ paddingLeft: "5px", paddingRight: "18px" }}>
                                <p className="inline helvetica" style={{ fontSize: "14px" }}>
                                  {roundToTwo(row.Allocation)}%
                                </p>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={5}>
                        <SoftBox mt={3} textAlign="center">
                          <CircularProgress />
                        </SoftBox>
                      </td>
                    </tr>
                  )}
                  {/* Add more rows as needed */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </SoftBox>
      {sectorData && (
        <SoftBox mb={3}>
          <div style={{ backgroundColor: "white", borderRadius: "16px", marginTop: "20px", padding: "20px" }}>
            <div
              style={{
                marginBottom: "18px",
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                alignItems: "center",
              }}
            >
              <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
                Key Financial Ratios
              </h3>
            </div>
            {loading ? (
              <SoftBox mt={3} textAlign="center">
                <CircularProgress />
              </SoftBox>
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          class=" bbvColour1"
                          style={{
                            color: "white",
                            width: "300px",
                            textAlign: "left",
                            paddingLeft: "10px",
                            height: "5px",
                          }}
                        >
                          Key Financial Ratios
                        </th>
                        <th
                          class="bbvColour2"
                          style={{
                            color: "white",
                            paddingLeft: "10px",
                            width: "150px",
                            textAlign: "left",
                            height: "5px",
                          }}
                        >
                          Info
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ borderBottom: "1px solid #ddd", height: "40px", paddingTop: "10px" }}>
                          <div className="inline " style={{ paddingLeft: "5px", paddingRight: "18px" }}>
                            <div className="inline  infoIcon">
                              <InfoIcon
                                onClick={() => {
                                  handleInfoPop("PERatio");
                                }}
                                className="icon"
                              />
                            </div>
                            <p className="inline helvetica" style={{ fontSize: "14px" }}>
                              Price to Earnings (PE) Ratio
                            </p>
                          </div>
                        </td>
                        <td style={{ borderBottom: "1px solid #ddd" }}>
                          <div style={{ paddingLeft: "10px" }}>
                            <TLSText
                              higherBetter={false}
                              value={roundToTwo(sectorData["PE_Ratio"])}
                              green={roundToTwo(sectorData["PE_Ratio"]) <= 0}
                            />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ borderBottom: "1px solid #ddd", height: "40px", paddingTop: "10px" }}>
                          <div className="inline " style={{ paddingLeft: "5px", paddingRight: "18px" }}>
                            <div className="inline  infoIcon">
                              <InfoIcon
                                onClick={() => {
                                  handleInfoPop("TYS");
                                }}
                                className="icon"
                              />
                            </div>
                            <p className="inline helvetica" style={{ fontSize: "14px" }}>
                              3 Year Sharpe Ratio
                            </p>
                          </div>
                        </td>
                        <td style={{ borderBottom: "1px solid #ddd", height: "40px", paddingTop: "10px" }}>
                          <div style={{ paddingLeft: "10px" }}>
                            <TLSText higherBetter={true} value={roundToTwo(sectorData["3y_SharpRatio"])} />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Grid>
                <Grid item xs={12} md={6}>
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          class=" bbvColour1"
                          style={{
                            color: "white",
                            width: "300px",
                            textAlign: "left",
                            paddingLeft: "10px",
                            height: "5px",
                          }}
                        >
                          Key Financial Ratios
                        </th>
                        <th
                          class="bbvColour2"
                          style={{
                            color: "white",
                            paddingLeft: "10px",
                            width: "150px",
                            textAlign: "left",
                            height: "5px",
                          }}
                        >
                          Info
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ borderBottom: "1px solid #ddd", height: "40px", paddingTop: "10px" }}>
                          <div className="inline " style={{ paddingLeft: "5px", paddingRight: "18px" }}>
                            <div className="inline  infoIcon">
                              <InfoIcon
                                onClick={() => {
                                  handleInfoPop("RET");
                                }}
                                className="icon"
                              />
                            </div>
                            <p className="inline helvetica" style={{ fontSize: "14px" }}>
                              Returns 5 Year
                            </p>
                          </div>
                        </td>
                        <td style={{ borderBottom: "1px solid #ddd", height: "40px", paddingTop: "10px" }}>
                          <div style={{ paddingLeft: "10px" }}>
                            <TLSText higherBetter={true} value={roundToTwo(sectorData["Returns_5Y"])} />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ borderBottom: "1px solid #ddd", height: "40px", paddingTop: "10px" }}>
                          <div className="inline " style={{ paddingLeft: "5px", paddingRight: "18px" }}>
                            <div className="inline  infoIcon">
                              <InfoIcon
                                onClick={() => {
                                  handleInfoPop("RET");
                                }}
                                className="icon"
                              />
                            </div>
                            <p className="inline helvetica" style={{ fontSize: "14px" }}>
                              Returns Year to Date (YTD)
                            </p>
                          </div>
                        </td>
                        <td style={{ borderBottom: "1px solid #ddd", height: "40px", paddingTop: "10px" }}>
                          <div style={{ paddingLeft: "10px" }}>
                            <TLSText higherBetter={true} value={roundToTwo(sectorData["Returns_YTD"])} />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Grid>
              </Grid>
            )}
          </div>
        </SoftBox>
      )}
      <SoftBox mb={3}>
        <div style={{ backgroundColor: "white", borderRadius: "16px", marginTop: "20px", padding: "20px" }}>
          <div
            style={{
              marginBottom: "18px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
              Industry Allocations
            </h3>
          </div>
          {loading ? (
            <SoftBox mt={3} textAlign="center">
              <CircularProgress />
            </SoftBox>
          ) : (
            <>
              {pieData && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <PieChart title="" description="" chart={revenueData1} options={{}} showLabels={true} />
                </div>
              )}
              {sector === "XLB" && (
                <SoftTypography>
                  The Materials Select Sector SPDR Fund (XLB) is an ETF that provides targeted exposure to the materials
                  sector, including industries like chemicals, metals, mining, and construction materials. Its
                  performance is closely tied to economic cycles, commodity prices, and industrial demand. Investors can
                  use XLB to diversify their portfolios, hedge against inflation, or implement sector rotation
                  strategies by investing during periods of economic growth or rising commodity prices. Monitoring
                  macroeconomic trends, commodity markets, and earnings reports of top holdings can help make informed
                  decisions when using XLB to capitalize on cyclical opportunities or as part of a balanced investment
                  approach.
                </SoftTypography>
              )}
              {sector === "XLE" && (
                <SoftTypography>
                  The Energy Select Sector SPDR Fund (XLE) is an ETF that provides focused exposure to the energy
                  sector, including companies involved in oil, natural gas, and energy equipment and services. Its
                  performance is influenced by energy prices, geopolitical events, supply-demand dynamics, and the
                  global economic environment. Investors can use XLE to capitalize on rising energy prices, hedge
                  against inflation, or diversify their portfolios with exposure to energy-related industries. By
                  analyzing macroeconomic trends, oil and gas market developments, and the earnings of major energy
                  companies, investors can use XLE to make informed decisions, particularly during periods of strong
                  energy demand or supply constraints
                </SoftTypography>
              )}
              {sector === "XLF" && (
                <SoftTypography>
                  The Financial Select Sector SPDR Fund (XLF) is an ETF that provides exposure to the financial sector,
                  including banks, insurance companies, investment firms, and real estate-related services. Its
                  performance is heavily influenced by interest rates, economic growth, credit demand, and regulatory
                  changes. Investors can use XLF to benefit from economic expansions, when financial institutions
                  typically see higher profitability due to increased lending and investment activity. Monitoring
                  macroeconomic indicators such as GDP growth, interest rate trends, and earnings reports of top
                  financial companies can help investors time their entry and exit, making XLF a useful tool for sector
                  rotation, diversification, or targeted exposure to the financial sector during favorable conditions.
                </SoftTypography>
              )}
              {sector === "XLI" && (
                <SoftTypography>
                  The Industrial Select Sector SPDR Fund (XLI) is an ETF that provides exposure to the industrial
                  sector, including companies involved in manufacturing, aerospace and defense, transportation, and
                  infrastructure development. Its performance is closely tied to economic growth, business investment
                  cycles, and infrastructure spending. Investors can use XLI to capitalize on economic expansions, where
                  demand for industrial goods and services typically rises, or to gain exposure to infrastructure
                  projects and innovations in manufacturing. By analyzing key economic indicators such as industrial
                  production, durable goods orders, and capital expenditure trends, as well as monitoring the earnings
                  of top industrial companies, investors can use XLI strategically to align their portfolios with growth
                  opportunities in the industrial sector.
                </SoftTypography>
              )}
              {sector === "XLK" && (
                <SoftTypography>
                  The Technology Select Sector SPDR Fund (XLK) is an ETF that provides exposure to the technology
                  sector, including companies in software, hardware, semiconductors, IT services, and related fields.
                  Its performance is driven by innovation, consumer demand for tech products, corporate IT spending, and
                  overall economic trends. Investors can use XLK to capitalize on the growth potential of leading tech
                  companies, diversify portfolios, or gain targeted exposure to technological advancements. By
                  monitoring macroeconomic trends, industry innovations, and earnings reports of top tech companies,
                  investors can use XLK strategically, particularly during periods of strong market sentiment toward
                  technology or when disruptive innovations are driving significant sector growth.
                </SoftTypography>
              )}
              {sector === "XLP" && (
                <SoftTypography>
                  The Consumer Staples Select Sector SPDR Fund (XLP) is an ETF that provides exposure to the consumer
                  staples sector, which includes companies producing essential goods like food, beverages, household
                  products, and personal care items. These products tend to have stable demand regardless of economic
                  conditions, making XLP less volatile and often seen as a defensive investment. Investors can use XLP
                  to diversify portfolios, reduce risk during market downturns, or hedge against economic uncertainty.
                  By analyzing consumer spending trends, inflation data, and earnings reports of major consumer staples
                  companies, investors can use XLP to make informed decisions, particularly when seeking stability or
                  income through dividends in challenging economic environments.
                </SoftTypography>
              )}
              {sector === "XLRE" && (
                <SoftTypography>
                  The Real Estate Select Sector SPDR Fund (XLRE) is an ETF that provides exposure to the real estate
                  sector, including companies that own, develop, and manage properties like residential, commercial, and
                  industrial real estate, as well as real estate investment trusts (REITs). Its performance is
                  influenced by factors such as interest rates, economic growth, property market trends, and inflation.
                  Investors can use XLRE to diversify their portfolios, hedge against inflation (as real estate often
                  retains value during inflationary periods), or gain income through dividends, as REITs are required to
                  distribute most of their earnings. Monitoring interest rate movements, housing market trends, and
                  macroeconomic indicators can help investors use XLRE effectively, particularly when seeking stable
                  income or exposure to real estate market growth.
                </SoftTypography>
              )}
              {sector === "XLU" && (
                <SoftTypography>
                  The Utilities Select Sector SPDR Fund (XLU) is an ETF that provides exposure to the utilities sector,
                  which includes companies involved in electricity, water, and natural gas distribution. Utilities are
                  considered a defensive sector because their services are essential and maintain steady demand
                  regardless of economic conditions. XLU is often used by investors seeking stability, low volatility,
                  and reliable dividend income, especially during market downturns or periods of economic uncertainty.
                  To make informed investment decisions with XLU, monitor interest rates (as utilities are sensitive to
                  rate changes due to high debt levels) and economic conditions, using it as a safe haven during
                  volatile markets or to add consistent income to a diversified portfolio.
                </SoftTypography>
              )}
              {sector === "XLV" && (
                <SoftTypography>
                  The Health Care Select Sector SPDR Fund (XLV) is an ETF that provides exposure to the healthcare
                  sector, including companies involved in pharmaceuticals, biotechnology, healthcare equipment, and
                  services. This sector is known for its resilience, as demand for healthcare products and services
                  remains strong regardless of economic cycles. Investors can use XLV to diversify portfolios, hedge
                  against economic downturns, or capitalize on innovation in drug development and medical technology. By
                  analyzing demographic trends (e.g., aging populations), regulatory changes, and the earnings of top
                  healthcare companies, investors can use XLV to make strategic decisions, especially when seeking
                  stability or growth opportunities in a vital and innovative sector.
                </SoftTypography>
              )}
              {sector === "XLY" && (
                <SoftTypography>
                  The Consumer Discretionary Select Sector SPDR Fund (XLY) is an ETF that provides exposure to the
                  consumer discretionary sector, which includes companies that sell non-essential goods and services,
                  such as retail, automobiles, entertainment, and consumer services. This sector is more sensitive to
                  economic cycles, as consumer spending on discretionary items tends to rise during periods of economic
                  growth and decline during recessions. Investors can use XLY to capitalize on periods of economic
                  expansion when consumer confidence and spending are high, or to gain exposure to leading companies in
                  retail, media, and luxury goods. By monitoring consumer confidence, spending trends, and the economic
                  outlook, investors can use XLY to make informed decisions about positioning their portfolios for
                  growth during favorable economic conditions.
                </SoftTypography>
              )}
              {sector === "XLC" && (
                <SoftTypography>
                  The Communication Services Select Sector SPDR Fund (XLC) is an ETF that provides exposure to the
                  communication services sector, which includes companies involved in media, telecommunications,
                  entertainment, and internet services. This sector includes major players in areas like social media,
                  broadcasting, cable, and streaming services. XLC tends to benefit from technological advancements and
                  shifts in consumer behavior, such as the growing demand for digital media and internet-based
                  communication. Investors can use XLC to capitalize on trends like the increasing consumption of
                  streaming content, digital advertising, and the expansion of 5G networks. By monitoring market trends,
                  consumer behavior, and technological innovations, investors can use XLC to make strategic decisions,
                  particularly during periods of growth in digital communication and media sectors.
                </SoftTypography>
              )}
            </>
          )}
        </div>
      </SoftBox>
      <SoftBox mb={3}>
        <div style={{ backgroundColor: "white", borderRadius: "16px", marginTop: "20px", padding: "20px" }}>
          <div
            style={{
              marginBottom: "18px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <h3 className="roboto" style={{ textAlign: "center", marginRight: "5px" }}>
              Market Cap Comparison Chart
            </h3>
          </div>
          <div
            style={{
              marginTop: "5px",
              marginBottom: "5px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <p className="roboto" style={{ textAlign: "center", fontSize: "18px", marginRight: "5px" }}>
              {sector} vs S&P 500 Index ETF (SPY)
            </p>
          </div>
          {marketCap && !loading ? (
            <DualAxisLineChart title="" description="" chart={marketCap} options={{}} />
          ) : (
            <SoftBox mt={3} textAlign="center">
              <CircularProgress />
            </SoftBox>
          )}
        </div>
      </SoftBox>
      {infoPopup ? <StockInfoPopup toggleInfoPopup={toggleInfoPopup} popupAccessor={popupAccessor} /> : <div></div>}
    </DashboardLayout>
  );
};
